import { getIdentity } from "../components/common/commonFuncs";
import { config } from "../config";
import http from "./httpService";

const prefix = '/api/v2/forms/';
const apiEndpoint = config.apiEndpoint;

export function updateEmailSettings(Project_ID, emailTemplate){
	return http.post(apiEndpoint + prefix + 'updateEmailSettings', { 
		Project_ID:Project_ID,
        Activity_By: getIdentity()
	 });
} 